<template>
    <div class="overlay">
        <div class="container">
            <div class="content">
                <div v-if="popTipsValue === 1">請注意，所上傳之證件複本必須為完整複本，包含申請人照片，清晰可讀，並無遮蓋任何資料，盡可能放大至影框大少。<br>並必須在證件複本旁簽署核實，如下圖例子。<br><img src="../assets/china-id.jpg" alt=""></div>
                <div v-if="popTipsValue === 2">請注意，所上傳之銀行卡複本必須為完整複本，清晰可讀，並無遮蓋任何資料，盡可能放大至影框大少。</div>
                <div v-if="popTipsValue === 3">請注意，所上傳之住址證明必須為完整複本，清晰可讀，並無遮蓋任何資料，盡可能放大至影框大少。<br>有效的住址證明需由公營機構發出的信件、銀行賬單等；詳細可接納的住址證明，請查閱您的居住地之標準。</div>
            </div>
            <div class="btn-container">
                <div class="btn" @click="close">我明白了</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "popTips",
        props:{
            popTipsValue: Number,
            /* popTipsValue: [1,2,3] equal to file1, file2, file3 */
            close: Function
        },
        data: () => ({

        }),
        components: {
        }
    }
</script>

<style lang="scss">
</style>
